/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_RestoredInputs */

const zh_subscription_restored = /** @type {(inputs: Subscription_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已恢复订阅`)
};

const en_subscription_restored = /** @type {(inputs: Subscription_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription restored`)
};

const es_subscription_restored = /** @type {(inputs: Subscription_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción restaurada`)
};

/**
* | output |
* | --- |
* | "Subscription restored" |
*
* @param {Subscription_RestoredInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_restored = /** @type {((inputs?: Subscription_RestoredInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_RestoredInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_restored(inputs)
	if (locale === "en") return en_subscription_restored(inputs)
	return es_subscription_restored(inputs)
});